import { faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@mui/material';
import { ReactNode } from 'react';

import './styles.scss';

interface InputTooltipProps {
  content: ReactNode;
}

export const InputTooltip = ({ content }: InputTooltipProps) => {
  return (
    <Tooltip
      title={content}
      classes={{ tooltip: 'backtesting-input-tooltip-content' }}
      placement="right-start"
    >
      <span className="backtesting-input-tooltip-trigger">
        <FontAwesomeIcon icon={faInfoCircle} />
      </span>
    </Tooltip>
  );
};
